var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveAssets(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.445,
    height: 18.445,
    viewBox: "0 0 18.445 18.445",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .activeAsset {\r\n        fill: #1bc47d;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18680",
    "data-name": "Group 18680",
    transform: "translate(-216.5 -11.055)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Solid_General_Chart-pie-alt",
    "data-name": "Solid / General /Chart-pie-alt",
    transform: "translate(213 8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chart-pie-alt",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "activeAsset",
    d: "M7.938,6.947A8,8,0,0,0,1,.007.911.911,0,0,0,0,.945v6.5a.5.5,0,0,0,.5.5H7A.911.911,0,0,0,7.938,6.947Z",
    transform: "translate(11 0.055)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    className: "activeAsset",
    d: "M8.5,0A8.5,8.5,0,1,0,17,8.5a.5.5,0,0,0-.5-.5h-7A.5.5,0,0,1,9,7.5V.5A.5.5,0,0,0,8.5,0Z",
    transform: "translate(0.5 1.5)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveAssets);
export default __webpack_public_path__ + "static/media/active-assets.7deffc264ba7180a0417cdfcd499da7c.svg";
export { ForwardRef as ReactComponent };